import { createSelector } from "reselect";

export const getCreditBookmarks = (state) =>
  state.creditBookmarkState.creditBookmarks;

export const getTotalNumberOfCreditBookmarks = createSelector(
  // getCreditBookmarks,
  (state) => state,
  (state) => {
    const creditBookmarks = state.creditBookmarkState.creditBookmarks;
    //only count bookmarks exist in the datasource as well
    return creditBookmarks.length;
  },
);
